/* *********************************************************************************** */
/* This file is a plain JS-file to prevent dealing with types on the globalThis object */
/* *********************************************************************************** */

// Import react dependencies
import "./global/baseinit.js";

// Import base css file in order for css to get built
import './index.css';

// import components and pages that can be used in the global scope Html.React() function
import components from './src/components';
import pages from './src/pages';

// Expose react components as a global variable
globalThis.ReactComponents = components;
globalThis.ReactPages = pages;
